<template>
  <aside
    :class="[
      'shrink-0 h-screen bg-base-800 border-r border-line flex flex-col transition-all duration-300',
      isSidebarOpen ? 'w-64' : 'w-[76px]',
    ]"
  >
    <!-- Header / logo -->
    <div class="flex items-center h-16 px-4 border-b border-line" :class="isSidebarOpen ? 'justify-between' : 'justify-center'">
      <!-- Open: logo + wordmark links to dashboard -->
      <a v-if="isSidebarOpen" href="/dashboard" class="flex items-center gap-2.5 overflow-hidden">
        <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-9 w-9 object-contain shrink-0" />
        <span class="text-sm font-extrabold tracking-tight text-white whitespace-nowrap">
          Akademi<span class="text-brand">Siber</span>
        </span>
      </a>
      <!-- Open: collapse toggle -->
      <button
        v-if="isSidebarOpen"
        @click="toggleSidebar"
        class="h-9 w-9 grid place-items-center rounded-lg text-ink-muted hover:text-white hover:bg-surface-light transition-colors"
        aria-label="Collapse sidebar"
      >
        <i class="fas fa-angle-left"></i>
      </button>
      <!-- Collapsed: logo doubles as expand button (keeps the brand mark visible) -->
      <button
        v-else
        @click="toggleSidebar"
        class="group relative h-10 w-10 grid place-items-center rounded-lg hover:bg-surface-light transition-colors"
        aria-label="Expand sidebar"
        title="Expand"
      >
        <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-8 w-8 object-contain group-hover:opacity-0 transition-opacity" />
        <i class="fas fa-angle-right absolute text-ink-muted opacity-0 group-hover:opacity-100 transition-opacity"></i>
      </button>
    </div>

    <!-- Nav -->
    <nav class="flex-1 overflow-y-auto px-3 py-5 space-y-6">
      <div v-for="group in groups" :key="group.title">
        <p
          v-if="isSidebarOpen"
          class="px-3 mb-2 text-[10px] font-bold uppercase tracking-[0.18em] text-ink-faint"
        >
          {{ group.title }}
        </p>
        <div class="space-y-1">
          <a
            v-for="item in group.items"
            :key="item.href"
            :href="item.href"
            :title="item.label"
            :class="[
              'group relative flex items-center rounded-lg px-3 py-2.5 text-sm font-medium transition-all',
              isActive(item.href)
                ? 'bg-surface-light text-white'
                : 'text-ink-muted hover:text-white hover:bg-surface-light/60',
              isSidebarOpen ? '' : 'justify-center',
            ]"
          >
            <span
              v-if="isActive(item.href)"
              class="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-1 rounded-r-full bg-brand-gradient"
            ></span>
            <i
              :class="[
                item.icon,
                'text-base w-5 text-center transition-colors',
                isActive(item.href) ? 'text-brand' : 'text-ink-faint group-hover:text-brand',
              ]"
            ></i>
            <span v-if="isSidebarOpen" class="ml-3 whitespace-nowrap">{{ item.label }}</span>
          </a>
        </div>
      </div>
    </nav>

    <!-- Footer -->
    <div class="shrink-0 p-3 border-t border-line">
      <template v-if="isSidebarOpen">
        <div class="flex items-start justify-center gap-4 mb-2">
          <div class="text-center">
            <p class="text-ink-faint text-[10px] mb-1">Brought to you by</p>
            <img src="@/assets/partners/siberlab-logo.png" alt="SiberLab ID" class="h-5 mx-auto object-contain" />
          </div>
          <div class="text-center">
            <p class="text-ink-faint text-[10px] mb-1">In partnership with</p>
            <img src="@/assets/partners/redac7d.png" alt="REDAC7D" class="h-5 mx-auto object-contain" />
          </div>
        </div>
        <p class="text-ink-faint/70 text-[10px] text-center">© {{ year }} SiberLab ID</p>
      </template>
      <div v-else class="flex justify-center">
        <img src="@/assets/partners/siberlab-logo.png" alt="SiberLab ID" class="h-5 object-contain opacity-70" />
      </div>
    </div>
  </aside>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "Sidebar",
  data() {
    return {
      isSidebarOpen: true,
      year: new Date().getFullYear(),
      groups: [
        {
          title: "Main",
          items: [
            { label: "Dashboard", href: "/dashboard", icon: "fas fa-tachometer-alt" },
            { label: "Course Modules", href: "/modules", icon: "fas fa-book" },
            { label: "Leaderboard", href: "/leaderboard", icon: "fas fa-trophy" },
          ],
        },
        {
          title: "Labs",
          items: [
            { label: "Cybergym Lab", href: "/machine-labs", icon: "fas fa-server" },
            { label: "AI Mentored Lab", href: "/ai-labs", icon: "fas fa-robot" },
          ],
        },
      ],
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    handleResize() {
      if (window.innerWidth < 768) this.isSidebarOpen = false;
    },
    isActive(href) {
      return this.$route.path === href || this.$route.path.startsWith(href + "/");
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
